module.exports = {"id":"203299","name":"André Carrillo","rating":"78","photo":"./data/images/photos/2/203299.png","club":{"name":"Watford","logo":"./data/images/clubs/Watford.png"},"positions":["MD","AD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreCarrillo0.json
// module id = 335
// module chunks = 0